<template>
    <v-dialog v-model="generatePopup" width="800" :height="flowType === 'Article' ? 800 : 500" :persistent = "createBtnLoader || isFormValid">
        <div class="popup-container">
            <div class="header">
                <div class="tile">Create {{ flowType }}</div>
                <button class="circle" @click="closePopup">
                    <img :src="require('@/assets/icons/close.svg')" alt="">
                </button>
            </div>
            <div class="sub-header">
                <span>Input Document</span>
                <div class="pr-title-container">
                    <div class="pr-title">{{ this.documentData.documentName }}</div>
                    <div class="sub-title">
                        <Svg :src="documentData.imageUrl" class="overlay"></Svg>
                        {{ {
                            PR: 'Press Release',
                            BUISNESS_NARRATVE: 'Narrative',
                            ARTICLE: 'Article',
                            MESSAGE_HOUSE: 'Message House',
                        }[this.documentData.documentType] || ''
                        }}
                    </div>
                </div>
            </div>
            <v-form v-model="isFormValid" class="popup-body">
                <div class="popup-input">
                    <div class="label">Document Name</div>
                    <v-text-field v-model="docName" :rules="[nameRules]" variant="outlined"
                        placeholder="eg. New product launch overview" density="compact"
                        bg-color="var(--bg-color)" :disabled="createBtnLoader"></v-text-field>
                </div>
                <div v-if="flowType === 'Article'">
                    <div class="key-header">
                        <div class="key-title">
                            <Svg :src="require('@/assets/icons/focus.svg')" alt="create" height="20px"
                                width="20px"></Svg>
                            Key Text to Focus
                            <span class="required">*</span>
                        </div>

                    </div>
                    <div class="wrapper">
                        <textarea class="custom-native-textarea" v-model="selectedSection"
                            placeholder="Copy and paste a section from the selected document that should guide the output"
                            @input="autoResizeTextarea" :disabled="createBtnLoader" required></textarea>

                    </div>

                </div>

            </v-form>
            <div class="popup-footer">
                <button class="discard-btn" @click.prevent="closePopup" :disabled = "createBtnLoader">
                    <span>Cancel</span>
                </button>
                <button class="save-changes-btn" @click="generateModule" :disabled="createBtnLoader || (flowType === 'Article' && !selectedSection?.trim())">
                    <span>Generate {{ flowType }}</span>
                    <v-progress-circular v-if="createBtnLoader" indeterminate :size="18" class="gradient-spinner"
                        :width="2"></v-progress-circular>
                </button>
            </div>



        </div>
    </v-dialog>
</template>

<script>
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import axios from 'axios';
import Cookies from 'js-cookie';
export default {

    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        flowType: {
            type: String,
        },
        documentData: {
            type: Object,
        }

    },
    data() {
        return {
            isFormValid: false,
            selectedSection:null,
            docName: null,
            createBtnLoader: false,
            prCampaignId: null,
            socialStrategyId: null,
            articleId: null,
            socialMediaId: null,
            storyBankId: null
        }
    },
    computed: {
        generatePopup: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
        nameRules() {
            return (value) => {
                if (!value) return true;
                else if (value.length < 3) return "Document name must be at least 3 characters";
                else if (value.length > 100) return 'Document name must be less than 100 characters';
                else return true;
            }
        },
        articleRules() {
            return (value) => {
                if (!value) return false;
                else return true;
            }
        },
        isFormValid(){
            return this.docName;
        }
    },
    methods: {
        closePopup() {
            if(this.createBtnLoader === true){
                this.generatePopup = true;
            } else{
                this.generatePopup = false;
                this.docName = '';
                this.selectedSection = '';
            }
        },
        async addNewSocialStrategy() {
            try {
                this.createBtnLoader = true;
                const response = await axiosInstance.post('/socialMedia/create', {
                    docName: this.docName
                });
                if (response.status === 201) {
                    this.socialStrategyId = response.data.data.socialStrategyId;
                    this.generateSocialStrategy();

                }
            } catch (error) {
                Eventbus.emit({
                    snackType: 'error',
                    message: 'Failed to create Social Media Campaign'
                })
            } finally {

            }
        },
        addNewPrPlan() {

            let payload = {
                title: this.docName,
            }
            this.createBtnLoader = true;
            axiosInstance.post('/prCampaign/create', payload)
                .then((response) => {
                    this.prCampaignId = response.data.data.prCampaignId
                    this.generatePrCampaign()
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new PR Strategy'
                    })
                })
                .finally(() => {
                })
        },
        

        // async suggestArticle() {

        //     try {
        //         const payload = {
        //             documentType: this.documentData.documentType,
        //             documentId: this.documentData.documentId,
        //             articleId: this.articleId,
        //             sectionContent: this.selectedSection,
        //         };
        //         const response = await axiosInstance.post('/article/suggest', payload);
        //         if (response.status === 201) {
        //             this.$router.push({ name: 'ArticleStages', params: { articleId: this.articleId } });
        //         }
        //     } catch (error) {
        //         console.error("Error generating Article", error);
        //         Eventbus.emit('commonSnackbar', {
        //             snackType: 'error',
        //             message: 'Something went wrong, Please try again!',
        //         });
        //     } finally {
        //         this.createBtnLoader = false;

        //     }
        // },

        async generateSocialStrategy() {
            try {
                const payload = {
                    documentType: this.documentData.documentType,
                    documentId: this.documentData.documentId,
                    socialStrategyId: this.socialStrategyId
                };
                const response = await axiosInstance.post('/socialMedia/calendar', payload);

                if (response.status === 200 && response.data.success) {
                    this.socialMediaCalendar = response.data;

                    if (response.data.data?.calendarContent) {
                        this.calendarItems = response.data.data.calendarContent;
                    }
                    this.$router.push({ name: 'SocialStrategyDetails', params: { socialStrategyId: this.socialStrategyId } });
                }
            } catch (error) {
                console.error("Error generating Social Media Campaign", error);
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Something went wrong, Please try again!',
                });

            } finally {
                this.createBtnLoader = false;
            }
        },


        async generatePrCampaign() {
            
            try {
                const payload = {
                    documentType: this.documentData.documentType,
                    documentId: this.documentData.documentId,
                    prCampaignId: this.prCampaignId
                }
                const response = await axiosInstance.post('/prCampaign/generate', payload);

                if (response.status === 200) {                    
                    this.createBtnLoader = false;
                    this.$router.push({ name: 'PrPlanDetails', params: { prCampaignId: this.prCampaignId } });
                }

            } catch (error) {
                console.error("Error generating PR Strategy", error);
                if (error.response?.status === 504 || error.code === 'ERR_NETWORK') {
                    setTimeout(() => {
                        this.createBtnLoader = false;
                        this.$router.push({
                            name: 'PrPlanDetails',
                            params: { prCampaignId: this.prCampaignId }
                        });
                    }, 30000);
                }
                else {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Something went wrong, Please try again!',
                    });

                }

            }

        },

        addNewStoryBank() {

            let payload = {
                title: this.docName,
            }
            this.createBtnLoader = true;
            axiosInstance.post('/storyBank/create', payload)
                .then((response) => {
                    this.storyBankId = response.data.data.storyBankId
                    this.generateStoryBank()
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new story bank'
                    })
                })
                .finally(() => {
                })
        },

        async generateStoryBank() {
            
            try {
                const payload = {
                    documentType: this.documentData.documentType,
                    documentId: this.documentData.documentId,
                    storyBankId: this.storyBankId
                }
                await axiosInstance.put('/storyBank/saveDraft',payload);
                const response = await axiosInstance.post('/storyBank/generate', payload);

                if (response.status === 200) {                    
                    this.createBtnLoader = false;
                    this.$store.dispatch('updateIsGeneratePopup', true);
                    this.$router.push({ name: 'StoryBankDetails', params: { storyBankId: this.storyBankId } });
                }

            } catch (error) {
                console.error("Error generating Story Bank", error);
                if (error.response?.status === 504 || error.code === 'ERR_NETWORK') {
                    setTimeout(() => {
                        this.createBtnLoader = false;
                        this.$router.push({
                            name: 'StoryBankDetails',
                            params: { storyBankId: this.storyBankId }
                        });
                    }, 30000);
                }
                else {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Something went wrong, Please try again!',
                    });

                }
            }

        },

        generateModule() {
            this.createBtnLoader = true;
            let moduleType = (this.flowType || '').replace(/\s+/g, '').toUpperCase();
            if (moduleType === 'PRSTRATEGYPLAYBOOK') {
                this.addNewPrPlan();

            } else if (moduleType === 'SOCIALMEDIACAMPAIGN') {
                this.addNewSocialStrategy()
            } else if (moduleType === 'ARTICLE') {
                this.addNewArticle();
            } else if (moduleType === 'STORYBANK') {
                this.addNewStoryBank();
            }
        }
    },
    mounted() {
    },
}
</script>

<style scoped>
.popup-container {
    background-color: #FFFFFF;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
}

.sub-header {
    padding: 16px;
    display: flex;
    flex-direction: column;
    background-color: #FFF3D3;
    border-bottom: 1px solid #D4D4D4;
    color: #737373;
    font-weight: 500;
}

.pr-title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 5rem;
}

.pr-title {
    color: var(--primary-font-color);
    font-weight: 600;
    font-size: var(--normal-font-size);
    display: flex;
    flex: 3;

}

.sub-title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid #D4D4D4;
    font-weight: 600;
    font-family: monospace;
    font-size: 24px;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 8px;
    border: 2px solid #D4D4D4;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 16px;
    overflow: auto;
    height: 100%;
}

.popup-input {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 500;
}

.popup-footer {
    display: flex;
    border-top: 1px solid #D4D4D4;
    justify-content: end;
    padding: 16px;
    gap: 1em;
}

.discard-btn {
    padding: 8px;
    border: 1px solid #D4D4D4;
    border-radius: 8px;
    font-weight: 500;
}

.save-changes-btn {
    padding: 8px;
    display: flex;
    gap: 4px;
    background: var(--primary-gradient-with-white);
    color: white;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    font-weight: 500;
}

.overlay {
    filter: brightness(0) saturate(100%) invert(83%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(83%) contrast(83%);
}

.wrapper {
    padding: 1rem;
    flex: 1;
    display: flex;
    min-height: 0;
}

.custom-native-textarea {
    width: 100%;
    height: 200px;
    padding: 8px;
    border: 1px solid #D4D4D4;
    border-radius: 12px;
    resize: none;
    overflow-y: auto;
    scrollbar-width: thin;
    font-size: 14px;
    font-style: italic;
}

.custom-native-textarea:focus {
    outline: none;
}


.key-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    gap: 4px;
    color: var(--primary-font-color);
    font-weight: 600;
    font-size: var(--normal-font-size);

}
</style>